import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/site";
import { MEDIA } from "@/data/media";

export default function Seo({ title, description, path = "", image, type = "website" }) {
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} | Los Angeles County Electrical Contractor`;
  const desc =
    description ||
    "Licensed California C-10 electrical contractor serving 91702 and Los Angeles County. Residential, commercial & industrial electrical plus CCTV and security camera installation.";
  const url = `${SITE.url}${path}`;
  const img = image || `${SITE.url}${MEDIA.og}`;
  const ld = {
    "@context": "https://schema.org",
    "@type": "Electrician",
    name: SITE.name,
    url: SITE.url,
    email: SITE.email,
    image: img,
    telephone: ["+16265395844", "+18183103235"],
    areaServed: SITE.county,
    sameAs: [SITE.googleUrl, SITE.tiktokUrl, SITE.yelpUrl],
    address: { "@type": "PostalAddress", addressRegion: "CA", postalCode: SITE.serviceZip, addressCountry: "US" },
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "06:00", closes: "18:00" },
    ],
  };
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </Helmet>
  );
}
